import _ from 'lodash'

export const addTrackingBasketData = (incomingData, stateData) => {
	const tempData = _.cloneDeep(stateData)
	return _.uniqBy(tempData.concat(incomingData), 'index')
}
